import axios from 'axios';
import { getAPIHost, getAppToken } from '../utils/helper';
import { isTokenValid, doLogout } from '../utils/auth';

axios.interceptors.request.use(async request => {
  request.headers['Content-Type'] = 'application/json';
  request.headers['ngrok-skip-browser-warning'] = 'true';

  const appToken = getAppToken();

  if (appToken) {
    if (await isTokenValid(appToken)) {
      // with valid token time

      request.headers['x-access-token'] = appToken;
    } else {
      await doLogout(true);
      throw new axios.Cancel();
    }
  }
  return request;
}, undefined);

axios.interceptors.response.use(
  response => {
    if (response.status === 204) {
      // patch the message for 204
      response.data = {
        returnMessage: response.headers['return-message'],
      };
    }
    return response;
  },
  async failedResponse => {
    if (failedResponse.response?.status === 401) {
      throw new axios.Cancel();
    }

    return Promise.reject(failedResponse);
  },
);

// eslint-comments/no-unused-disable
const baseUrl = getAPIHost() ?? '';
axios.defaults.baseURL = baseUrl.indexOf('localhost') > -1 ? baseUrl : `${baseUrl}/`;
axios.defaults.timeout = 15e3; // Set timeout value in milliseconds (e.g., 15 seconds)
